import { render, staticRenderFns } from "./imageLog.vue?vue&type=template&id=6081c848&scoped=true&"
import script from "./imageLog.vue?vue&type=script&lang=js&"
export * from "./imageLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081c848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6081c848')) {
      api.createRecord('6081c848', component.options)
    } else {
      api.reload('6081c848', component.options)
    }
    module.hot.accept("./imageLog.vue?vue&type=template&id=6081c848&scoped=true&", function () {
      api.rerender('6081c848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/imageLog.vue"
export default component.exports